module.exports = __webpack_public_path__ + "img/shimen-2.6c36a54f.jpg";